<template>
    <div class="col-xl-6 col-sm-12">
        <div class="checkout-details">
            <div class="order-box">
                <div class="title-box">
                    <div class="checkbox-title">
                        <h2 class="mb-0">Product </h2><span>Total</span>
                    </div>
                </div>
                <ul class="qty" v-if="cart.length">
                    <li v-for="(item, index) in cart" :key="index">
                        {{ item.name }} × {{ item.quantity }}
                        <span>${{ item.price * item.quantity }}</span>
                    </li>
                </ul>
                <ul class="qty" v-if="!cart.length">
                    <li v-if="!cart.length">There are no products in cart</li>
                </ul>
                <ul class="sub-total">
                    <li>Subtotal <span class="count">${{ getAmount }}</span></li>
                    <li class="shipping-class">Shipping
                        <div class="shopping-checkout-option">
                            <label class="d-block" for="chk-ani">
                                <input class="checkbox_animated" id="chk-ani" type="checkbox" checked="">Option 1
                            </label>
                            <label class="d-block" for="chk-ani1">
                                <input class="checkbox_animated" id="chk-ani1" type="checkbox">Option 2
                            </label>
                        </div>
                    </li>
                </ul>
                <ul class="sub-total total">
                    <li>Total <span class="count">${{ getAmount }}</span></li>
                </ul>
                <div class="animate-chk" v-if="cart.length">
                    <div class="row">
                        <div class="col">
                            <label class="d-block" for="edo-ani1">
                                <input class="radio_animated" id="edo-ani1" value="stripe" v-model="selectedPayment"
                                    type="radio" name="rdo-ani" data-original-title="">Stripe
                            </label>
                            <label class="d-block" for="edo-ani2">
                                <input class="radio_anima ted me-2" id="edo-ani2" value="paypal" v-model="selectedPayment"
                                    type="radio" name="rdo-ani" data-original-title="" title="">PayPal
                            </label>
                        </div>
                    </div>
                </div>
                <div id="paypal-button-container" :class="[{ 'd-none': selectedPayment != 'paypal' }]"></div>
                <div class="order-place" v-if="selectedPayment === 'stripe' && cart.length"><button class="btn btn-primary"
                        @click="payWithStripe">Place Order </button></div>
            </div>
        </div>
    </div>
</template>
<script>

import { mapState } from 'vuex';
export default {
    name: 'checkoutView',
    data() {
        return {
            activeAmount: "0", totalAmount: 0,
            user: {
                firstName: '', lastName: '', phone: '', email: '', address: '', city: '', state: '', pincode: ''
            },
            submitted: false, payment: false, complete: false, selectedPayment: 'stripe'
        }
    },
    created() {
        this.activeAmount = 60;
    },
    computed: {
        ...mapState({
            cart: state => state.product.cart,
            getAmount() {
                return (this.totalAmount = this.$store.getters['product/getTotalAmount']);
            }
        }),
    },
    methods: {
        payWithStripe() {
            this.payment = false
            var handler = (window).StripeCheckout.configure({});
            handler.open({
                name: 'Koho ', description: 'Your Choice Theme', amount: this.totalAmount * 100
            });
        },
    },
    mounted() {
        window.paypal.Buttons({}).render('#paypal-button-container')
    }
}
</script>